import { ViewerLinkApi, useAPIAction, useAPIQuery } from "melco-shared-logic";
import { useCallback } from "react";

// export const useValidateValidateLogin = (accessToken: string | null) => {
//   return useAPIQuery(
//     ViewerLinkApi,
//     ["validateValidateLogin", accessToken],
//     async (api) => {
//       if (accessToken == null) {
//         return;
//       }

//       return await api.statisticalViewerLinkValidate({
//         melcoMachineStatisticsModelsValidateAccessToken: {
//           access_token: accessToken,
//         },
//       });
//     }
//   );
// };

export const useValidateLogin = () => {
  const [ValidateLogin] = useAPIAction(
    ViewerLinkApi,
    async (api: ViewerLinkApi, ValidateLoginDetails: any) => {
      const { access_token } = ValidateLoginDetails;

      let data = await api.statisticalViewerLinkValidate({
        reportingMelcoMachineStatisticsModelsValidateAccessToken: {
          access_token: access_token,
        },
      });

      return {
        data,
        successMessages: [],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );

  return useCallback(
    async (ValidateLoginDetails: any) => {
      return await ValidateLogin(ValidateLoginDetails);
    },
    [ValidateLogin]
  );
};
